import PropTypes from 'prop-types';
import { List, ListItemButton, Paper, Popper, Typography } from '@mui/material';

// Slack-style ":shortcode:" autocomplete popup rendered above the composer.
// Pure presentational: selection state and keyboard handling live in the
// composer so its key events can take precedence over Enter-to-send.
export default function EmojiSuggestionList({
  anchorEl,
  suggestions,
  selectedIndex,
  onHoverIndex,
  onPick,
}) {
  const open = Boolean(anchorEl) && suggestions.length > 0;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement='top-start'
      style={{ zIndex: 1500 }}
      modifiers={[{ name: 'offset', options: { offset: [0, 6] } }]}
    >
      <Paper elevation={6} sx={{ width: 300, maxHeight: 320, overflowY: 'auto' }}>
        <List dense disablePadding>
          {suggestions.map((suggestion, index) => (
            <ListItemButton
              key={suggestion.id}
              selected={index === selectedIndex}
              onMouseEnter={() => onHoverIndex(index)}
              // onMouseDown so the composer input never loses focus on click.
              onMouseDown={e => {
                e.preventDefault();
                onPick(suggestion);
              }}
              sx={{ gap: 1, py: 0.5 }}
            >
              <Typography component='span' sx={{ fontSize: 20, lineHeight: 1 }}>
                {suggestion.native}
              </Typography>
              <Typography variant='body2' noWrap sx={{ flex: 1 }}>
                :{suggestion.id}:
              </Typography>
            </ListItemButton>
          ))}
        </List>
      </Paper>
    </Popper>
  );
}

EmojiSuggestionList.propTypes = {
  anchorEl: PropTypes.object,
  suggestions: PropTypes.array.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onHoverIndex: PropTypes.func.isRequired,
  onPick: PropTypes.func.isRequired,
};
